import { useContext } from "react"
import { Context } from "../store/store"

interface WinHeaderCopyProps {
	debugWin?: any
}

const WinHeaderCopy: React.FC<WinHeaderCopyProps> = ({ debugWin = null }) => {
	const { globalState } = useContext(Context)

	const content = {
		1: "nimm2 Lachgummi Vielfalt",
		2: "Setz dich auf die nimm2 Sonnenseite",
		3: "Für einen süßen Schlagabtausch",
		4: (
			<>
				nimm2 und nimm2 Lachgummi <br />
				Produktpaket
			</>
		),
		5: "nimm2 Badespaß",
		6: "nimm2 Picknickspaß",
		7: "Unterwegs mit Spaß im Gepäck",
	}

	if (debugWin === 0) {
		debugWin = 7
	}

	console.log(debugWin)

	if (content[debugWin ? debugWin : globalState.raffledPrizeCode]) {
		return <h2 className="h2 calenderCopyShadow lg:text-left mb-[40vw] md:mb-[200px]">{content[debugWin ? debugWin : globalState.raffledPrizeCode]}</h2>
	} else {
		return null
	}
}
export default WinHeaderCopy
